module.exports = __webpack_public_path__ + "static/media/persona_f_10_01.ce57d590.png";